var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { formatCurrency } from 'syf-js-utilities/formats';
import { faCalendar, faDollarSign } from '@fortawesome/pro-regular-svg-icons';
import useTranslation from '../../../../hooks/use-translation';
import { StyledBorder, StyledText } from '../../../subcomponents';
import Detail from './detail';
var PlanDetails = function (_a) {
    var plan = _a.plan;
    var i18n = useTranslation();
    var qualifyingPayment = plan.qualifyingPayment;
    return (_jsxs(_Fragment, { children: [_jsxs(Inset, __assign({ vertical: "xxlarge" }, { children: [_jsx(StyledText, __assign({ size: "medium", weight: "light" }, { children: i18n('plan.successDetailsHeading') })), _jsx(Stack, { size: "base" }), _jsx(StyledBorder, {}), _jsx(Stack, { size: "base" }), _jsx(Detail, { icon: faDollarSign, title: i18n('plan.totalAmountDueMonthlyLabel'), value: formatCurrency(qualifyingPayment) }), _jsx(Detail, { icon: faCalendar, title: i18n('plan.termLabel'), value: i18n('plan.termDetailsLabel') })] })), _jsx(Inset, { bottom: "xlarge" })] }));
};
export default PlanDetails;
//# sourceMappingURL=plan.js.map